module.exports = __webpack_public_path__ + "img/arrow_up.4af92010.3542069e.svg";